import { computed } from "vue";

import { useAccountViewState } from "./useAccountViewState";
import { useDropdownItems } from "@/composables/dropdown/useDropdownItems";

export function useTableConfig() {
  const viewState = useAccountViewState();
  const dropdownItems = useDropdownItems();
  const tableParams = computed(() => {
    return {
      headers: [
        {
          text: "User",
          sortable: true,
          value: "",
        },
        {
          text: "Account",
          sortable: false,
          value: "",
        },
        {
          text: "Access",
          sortable: false,
          value: "",
        },
        {
          text: "",
          sortable: false,
          value: "actions",
        },
      ],
      columns: [
        {
          field: "",
          component: "UserCard",
          props: (item) => ({
            class: "my-4",
            ...viewState.getUsersProps(item),
          }),
          events: () => ({}),
        },
        {
          field: "",
          component: "UserCard2",
          props: (item) => ({
            class: "my-4",
            ...viewState.getAccountOwnerProps(item),
          }),
          events: () => ({}),
        },
        {
          field: "",
          component: "UserStatusBadge",
          props: (item) => ({
            class: "my-4",
            ...viewState.getUserStatusBadgeProps(item),
          }),
          events: () => ({}),
        },
        {
          field: "",
          component: "Dropdown",
          props: (item) => ({
            "data-testid": "employee-operations-menu",
            translateXOffset: 3,
            translateYOffset: 2,
            isOpen: false,
            scrollContainerClass: ".ex-main-container",
            attachSelector: ".ex-main-container",
            absolute: true,
            dropdownItems: dropdownItems.getAdminAccountUsersItems(item),
          }),
          events: () => ({
            onClick: (operation) => {
              viewState.handleAccountUserDropdownOperation(operation);
            },
          }),
        },
      ],
      filters: {
        values: viewState.state.filters.values,
        searchText: viewState.state.filters.searchText,
      },
      hideTopSection: true,
      hideActiveNo: true,
      activeRecords: {
        field: "",
        value: "  ",
      },
      hideButtonInMessage: true,
      actionLabel: "Add Account",
      hideGridView: true,
      hideFilterBtn: true,
      showActionButton: viewState.state.filters.needsRecalculation
        ? false
        : true,
      title: "",
      getRowStyle: (item) => ({
        backgroundColor:
          item.position?.data?.status === "active" ? "#ECFDF3" : "#FFFFFF",
      }),
    };
  });
  return {
    tableParams,
  };
}
